export default class InitBanner {
  constructor() {
    this.cache = {
      $bannerInfo: $('.banner--info'),
    }
    if (this.cache.$bannerInfo.length) {
      this.setMargin()
    }
    if (document.querySelector('.banner--homepage')) {
      this.setHomepageBannerListeners()
    }
  }

  setMargin() {
    var margin = $('.banner--info__tile').height() / 2
    $('.banner--info h1').css('margin-bottom', margin + 'px')
    $('.banner--info__tile').css('margin-top', -margin + 'px')
  }

  setHomepageBannerListeners() {
    console.log('Homepage banner')
    const header = document.querySelector('.banner--homepage__header')
    const background = document.querySelector('.banner--homepage__background')

    header.addEventListener('mouseover', function () {
      background.classList.add('is-hovered')
    })
    header.addEventListener('mouseout', function () {
      background.classList.remove('is-hovered')
    })
  }
}
